import React from 'react';

const CTGStudy = (props) => {
  return (
    JSON.stringify(props.data?.ctg_data) !== '{}' ?
    <i className="fas fa-file-medical"></i>
    :
    <i className="fal fa-file-medical"></i>
  )
};

export default CTGStudy;